/*
import React, { useEffect, useState } from "react";
import axios from "axios";
import serverConfig from "../config";
import "./Home.css";
import SecondaryMenu from "../SecondaryMenu";

function InMemoryOfPeople() {
  const [textDedication, setTextDedication] = useState(null);
  const [listPeople, setListPeople] = useState(null);

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_in_memory_of`)
      .then((response) => {
        const data = response.data;
        setTextDedication(data['dedication']);
        setListPeople(data['people']);
      })
      .catch((error) => {
        //alert("ERRORE | get_in_memory_of");
        //console.log("CONFERENCE | get_in_memory_of | error", error);
      });
  }, []);

  return (
    <div>
      <div className="row">
        <div className="col-12 col-lg-2">
          <SecondaryMenu vertical={true}></SecondaryMenu>
        </div>
        <div className="col-12 col-lg-10">
        

          <div dangerouslySetInnerHTML={{ __html: textDedication }} />

        </div>
      </div>
    </div>
  );
}

export default InMemoryOfPeople;
*/

/*
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import serverConfig from "../config";
import "./InMemoryOfPeople.css";
import SecondaryMenu from "../SecondaryMenu";

// Componente SkeletonLoader per il caricamento
const SkeletonLoader = () => {
  return (
    <div className="container">
      <div className="row skeleton-row">
        <div className="col-md-6 col-sm-12 skeleton-card">
          <div className="skeleton-box"></div>
          <div className="skeleton-text"></div>
        </div>
        <div className="col-md-6 col-sm-12 skeleton-card">
          <div className="skeleton-box"></div>
          <div className="skeleton-text"></div>
        </div>
      </div>
    </div>
  );
};

// Componente InMemoryOfList per mostrare le persone
const InMemoryOfList = ({ listPeople }) => {
  if (!listPeople) {
    return <SkeletonLoader />;
  }

  return (
    <div className="container">
      {listPeople.map((person, index) => (
        <div className="row" key={index} style={{ margin: "10px", textAlign: "center" }}>
          <div className="col-md-6 col-sm-12 person-card">
            <div className="person-container">
              <Link
                to="/in_memory_of"
                className="custom-link"
                onClick={() => {
                  localStorage.setItem("person", person.name);
                  alert(`Hai selezionato ${person.name}`);
                }}
              >
                <img className="img-fluid" src={`${serverConfig.serverUrl}/${person.img}`} alt={person.name} />
                <div>
                  <b>{person.name} - {person.year}</b>
                </div>
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

// Componente principale
function InMemoryOfPeople() {
  const [textDedication, setTextDedication] = useState(null);
  const [listPeople, setListPeople] = useState(null);

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_in_memory_of`)
      .then((response) => {
        const data = response.data;
        setTextDedication(data["dedication"]);
        setListPeople(data["people"]);
      })
      .catch((error) => {
        console.error("Errore nel recupero dei dati: ", error);
      });
  }, []);

  return (
    <div>
      <div className="row">
        <div className="col-12 col-lg-2">
          <SecondaryMenu vertical={true} />
        </div>
        <div className="col-12 col-lg-10">
          <div dangerouslySetInnerHTML={{ __html: textDedication }} />
          <InMemoryOfList listPeople={listPeople} />
        </div>
      </div>
    </div>
  );
}

export default InMemoryOfPeople;

*/

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import serverConfig from "../config";
import "./InMemoryOfPeople.css";
import SecondaryMenu from "../SecondaryMenu";

import toast, { Toaster } from "react-hot-toast";

// for 2 person in row
/*
const InMemoryOfList = ({ listPeople }) => {
  if (!listPeople) return null;

  const groupedPeople = [];
  for (let i = 0; i < listPeople.length; i += 2) {
    groupedPeople.push(listPeople.slice(i, i + 2));
  }

  return (
    <div>
      {groupedPeople.map((group, rowIndex) => (
        <div className="row people-row" key={rowIndex}>
          {group.map((person, index) => (
            <div className="col-md-6 col-sm-12 person-card" key={index}>
              <div className="person-container">
                <Link
                  to="/in_memory_of"
                  className="custom-link"
                  onClick={() => {
                    localStorage.setItem("person", person.route);
                  }}
                >
                  <div className="image-container">
                    <img
                      className="img-fluid"
                      src={`${serverConfig.serverUrl}/${person.img}`}
                      alt={person.name}
                    />
                  </div>
                  <div className="person-name">
                    <b>{person.visualization_name}</b>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
*/

const InMemoryOfList = ({ listPeople }) => {
  if (!listPeople) return null;

  const groupedPeople = [];
  for (let i = 0; i < listPeople.length; i += 3) {
    groupedPeople.push(listPeople.slice(i, i + 3));
  }

  return (
    <div>
      {groupedPeople.map((group, rowIndex) => (
        <div className="row people-row" key={rowIndex}>
          {group.map((person, index) => (
            <div className="col-md-4 col-sm-12 person-card" key={index}>
              <div className="person-container">
                {/*
                <Link

                  className="custom-link"

                  to="/in_memory_of"
                  onClick={() => {
                    localStorage.setItem("person", person.route);
                  }}

                   //to={"/in_memory_of/"+person.route}
                   //href={window.location.origin + "/in_memory_of/" + person.route}
                   target="_blank"
                   rel="noopener noreferrer"
                >
                  
                  <div className="image-container">
                    <img
                      className="img-fluid"
                      src={`${serverConfig.serverUrl}/${person.img}`}
                      alt={person.name}
                    />
                  </div>
                  <div className="person-name">
                    <b>{person.visualization_name}</b>
                  </div>
                </Link>
                */}

                <a
                  className="custom-link"
                  href={
                    window.location.origin + "/in_memory_of-" + person.route
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}
                >
                  <div className="image-container">
                    <img
                      className="img-fluid"
                      src={`${serverConfig.serverUrl}/${person.img}`}
                      alt={person.name}
                    />
                  </div>
                  <div className="person-name">
                    <b>{person.visualization_name}</b>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

function InMemoryOfPeople() {
  const [textDedication, setTextDedication] = useState(null);
  const [listPeople, setListPeople] = useState(null);

  /*
  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_in_memory_of`)
      .then((response) => {
        setTextDedication(response.data["dedication"]);
        setListPeople(response.data["people"]);
      })
      .catch((error) => {
        //console.error("Errore nel recupero dei dati: ", error);
        toast.error("La risorsa non è al momento disponibile");
      });
  }, []);
  */

 const language = localStorage.getItem("language_dsm") || "it";

  useEffect(() => {
    axios
      .post(`${serverConfig.serverUrl}/get_in_memory_of`, { language: language.toLocaleLowerCase() })
      .then((response) => {
        setTextDedication(response.data["dedication"]);
        setListPeople(response.data["people"]);
      })
      .catch((error) => {
        toast.error("La risorsa non è al momento disponibile");
      });
  }, []);

  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const componentsInMemoryOfPeople = (
    <>
      <div dangerouslySetInnerHTML={{ __html: textDedication }} />
      <InMemoryOfList listPeople={listPeople} />
    </>
  );

  return (
    <div>
      {/*}
      <div className="row">
        <div className="col-12 col-lg-2">
          <SecondaryMenu vertical={true} />
        </div>
        <div className="col-12 col-lg-10">
          <div dangerouslySetInnerHTML={{ __html: textDedication }} />
          <InMemoryOfList listPeople={listPeople} />
        </div>
      </div>
      */}

      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <Toaster />
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>
              {componentsInMemoryOfPeople}
            </div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              {componentsInMemoryOfPeople}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default InMemoryOfPeople;
